export default 
`██████████████████████████████████
█████████Secret███████████████████
████████████Username:█████████████
██████████████Hugo1███████████████
████████████Password:█████████████
██████████████12345███████████████
██████████████████████████████████
██████████████████████████████████
██████████████████████████████████
██████████████████████████████████
██████████████████████████████████
██████████████████████████████████
██████████████████████████████████`